export default Object.freeze({
    TYPE: {
        LAB: 0,
        IMAGE: 1,
        OTHER: 2
    },
    STATUS: {
        REQUESTED: 0,
        IN_PROGRESS: 1,
        COMPLETED: 2
    },
    getTypeLabel(type, getLabel) {
        const map = {
            0: getLabel('LAB_EXAM_TYPE_LAB'),
            1: getLabel('LAB_EXAM_TYPE_IMAGE'),
            2: getLabel('LAB_EXAM_TYPE_OTHER')
        };
        return map[type] || getLabel('LAB_EXAM_TYPE_LAB');
    },
    getStatusLabel(status, getLabel) {
        const map = {
            0: getLabel('LAB_EXAM_STATUS_REQUESTED'),
            1: getLabel('LAB_EXAM_STATUS_IN_PROGRESS'),
            2: getLabel('LAB_EXAM_STATUS_COMPLETED')
        };
        return map[status] || getLabel('LAB_EXAM_STATUS_REQUESTED');
    },
    getTypeList(getLabel) {
        return [
            { value: 0, text: getLabel('LAB_EXAM_TYPE_LAB') },
            { value: 1, text: getLabel('LAB_EXAM_TYPE_IMAGE') },
            { value: 2, text: getLabel('LAB_EXAM_TYPE_OTHER') }
        ];
    },
    getStatusList(getLabel) {
        return [
            { value: 0, text: getLabel('LAB_EXAM_STATUS_REQUESTED') },
            { value: 1, text: getLabel('LAB_EXAM_STATUS_IN_PROGRESS') },
            { value: 2, text: getLabel('LAB_EXAM_STATUS_COMPLETED') }
        ];
    }
});
